
import { Link } from "react-router-dom";
import UserMenu from "../UserMenu";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Bell, Plus, Search, Briefcase, Menu } from "lucide-react"; // Added Search, Briefcase, Menu
import { useSidebar } from "@/components/ui/sidebar"; // Import useSidebar

interface TopNavbarProps {
  // Removed props as SidebarTrigger will be inside CrmSidebar or here if needed globally
}

export const TopNavbar = ({}: TopNavbarProps) => {
  const { user, isAdmin } = useAuth();
  const { toggleCollapsed } = useSidebar(); // Get toggle function from sidebar context

  // If no user, show a simplified navbar
  if (!user) {
    return (
      <div className="border-b sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="flex h-16 items-center px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2 font-semibold text-lg mr-6">
            <Briefcase size={24} className="text-primary" />
            <span className="font-bold">Go <span className="text-primary">eX</span>change</span>
          </Link>
          <div className="ml-auto">
            <Button variant="outline" asChild>
              <Link to="/auth">Login</Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  // Regular navbar for authenticated users
  return (
    <div className="border-b sticky top-0 z-40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 items-center px-4 md:px-6 gap-4">
        {/* Sidebar Toggle for mobile/tablet, or always visible if sidebar is fully collapsible */}
        <Button variant="ghost" size="icon" onClick={toggleCollapsed} className="md:hidden">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle Sidebar</span>
        </Button>

        <Link to="/dashboard" className="hidden md:flex items-center gap-2 font-semibold text-lg">
          <Briefcase size={24} className="text-primary" />
          <span className="font-bold">Go <span className="text-primary">eX</span>change</span>
        </Link>

        {/* Global Search */}
        <div className="flex-1 max-w-md ml-0 md:ml-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              type="search"
              placeholder="Search opportunities, contacts, companies..."
              className="pl-10 w-full h-9"
            />
          </div>
        </div>
        
        <div className="ml-auto flex items-center space-x-2 sm:space-x-4">
          <Button variant="default" size="sm" className="bg-primary hover:bg-primary/90">
            <Plus className="h-4 w-4 mr-2" />
            New Quote
          </Button>
          <Button variant="ghost" size="icon" aria-label="Notifications">
            <Bell className="h-5 w-5" />
          </Button>
          <UserMenu />
        </div>
      </div>
    </div>
  );
};

